var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"el-notification-fade"}},[_c('div',{ref:"lightTip",staticClass:"light-tip el-notification",class:_vm.show ? 'show' : ''},[(_vm.type == 'success')?_c('span',[_c('i',{staticClass:"icon el-icon-success"}),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.msg))])]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }